import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEmployeeMovementReady} from '../redux/employeesmovement'
import apiService from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'


import {Employees,Reasons} from '../../../common/DropDowns/index'


import DateTimeField from "react-bootstrap-datetimepicker";

import {Kitchens} from './DropDowns/index'


import * as Helpers from '../../../common/helpers'

class AddEmployeeMovement extends Component {

  constructor() {
    super()
    this.state = {

        bodyHeight: "0px",

        employeeData:{},
        selectedKitchen:{},

        remarks: "",
        toKitchenId: "",
        approverId: "",
        reasonId: "",

        movedOn:new Date(),

        remarksErrorText: false,
        remarksErrorData: '',

        toKitchenIdErrorText: false,
        toKitchenIdErrorData: '',

        approverIdErrorText: false,
        approverIdErrorData: '',

        reasonIdErrorText: false,
        reasonIdErrorData: '',

        subTitle: Constants.ADD_EMPLOYEE_MOVEMENT

    }

    this.isComponentStillMounted = true

    this.remarksComponent = null
    this.remarksSection = null

    this.toKitchenIdComponent = null
    this.toKitchenIdSection = null


    this.approverIdComponent = null
    this.approverIdSection = null

    this.reasonIdComponent = null
    this.reasonIdSection = null

}

componentWillMount() {
    this.isComponentStillMounted = true
    this.props.dispatch(addEmployeeMovementReady(false))
    window.addEventListener("resize", this.updateDimensions)
    this.updateDimensions()

    this.props.dispatch(subHeaderDataUpdate())

    if (this.props.employeesmovement && this.props.employeesmovement.employeeSelectedData && this.props.employeesmovement.employeeSelectedData !== null) {
        this.props.dispatch(headerDataUpdate(Constants.ADD_EMPLOYEE_MOVEMENT))
        this.setState({
            subTitle: "Create Employee Movement",
            selectedKitchen:this.props.employeesmovement.employeeSelectedData
        })

    } else {
        this.props.history.goBack()
    }

}

componentDidMount() {

    this.props.dispatch(addEmployeeMovementReady(true))
}

updateDimensions = () => {
    if (window.innerWidth <= 767) {
        this.setState({
            bodyHeight: (window.innerHeight - 130) + "px",
        })
    } else {
        this.setState({
            bodyHeight: (window.innerHeight - 100) + "px",
        })
    }
}

validateBuildNumber = (data) => {
    if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
        if (this.props.user.build_number === data.app_build_no) {
            //do smthng here
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    } else {
        this.props.dispatch(buildNumberUpdate(data.app_build_no))
        window.location.reload()
    }
}

componentWillUnmount() {
    this.isComponentStillMounted = false
    window.removeEventListener("resize", this.updateDimensions)
}


mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

onSaveClick = () => {

    this.props.dispatch(addEmployeeMovementReady(false))
    let data = {}


    let toKitchenIdObject = this.mandateValidation("toKitchenId", Constants.FORM_SELECT)
    if (toKitchenIdObject.status) {

        if(parseInt(this.toKitchenIdComponent.value,10)===parseInt(this.state.selectedKitchen.kitchen_id,10)){

                            this.dialog.show({
                                title: "Error!!",
                                body: "To Kitchen and From Kitchen should not be same.",
                                actions: [
                                    Dialog.OKAction(() => {
                                    })
                                ],
                            })

            this.props.dispatch(addEmployeeMovementReady(true))
            return
        }else{
            data.kitchen_staff_id=this.state.selectedKitchen.kitchen_staff_id
            data.from_kitchen_id=this.state.selectedKitchen.kitchen_id
            data.to_kitchen_id = this.toKitchenIdComponent.value
        }

    } else {
        this.props.dispatch(addEmployeeMovementReady(true))
        return
    }

    if(this.state.movedOn && this.state.movedOn!=="" && this.state.movedOn!==undefined){
        data.moved_on=this.state.movedOn
    }else{
        this.dialog.show({
                                title: "Error!!",
                                body: "Please select valid moved on date.",
                                actions: [
                                    Dialog.OKAction(() => {
                                    })
                                ],
                            })

            this.props.dispatch(addEmployeeMovementReady(true))
            return
    }


    let approverIdObject = this.mandateValidation("approverId", Constants.FORM_SELECT)
    if (approverIdObject.status) {
        data.approver_id = this.approverIdComponent.value
    } else {
        this.props.dispatch(addEmployeeMovementReady(true))
        return
    }


    let reasonIdObject = this.mandateValidation("reasonId", Constants.FORM_SELECT)
    if (reasonIdObject.status) {
        data.movement_reason_id = this.reasonIdComponent.value
    } else {

         this.props.dispatch(addEmployeeMovementReady(true))
        return
    }


    let remarksObject = this.mandateValidation("remarks", Constants.FORM_INPUT)
    if (remarksObject.status) {
        data.movement_remarks = this.remarksComponent.value
    } else {

         this.props.dispatch(addEmployeeMovementReady(true))
        return
    }



    data.employee_id=this.state.selectedKitchen.id

    let apiPayloadData=data;


    apiService.addEmployeeMovement(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEmployeeMovementReady(true))
                        this.props.history.goBack();
                    } else {

                        this.props.dispatch(addEmployeeMovementReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEmployeeMovementReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })




}

integerValidation = (value) => {
    if (/\D/.test(value)) {
        return true
    } else {
        return false
    }
}

onCancelClick = () => {
    this.props.history.goBack()
}




movedOnChange = (newDate) => {

    let movedOn=Helpers.getDateFormatForUTC(parseInt(newDate,10));

    this.setState({
        movedOn: movedOn
    });

}


 kitchenChange = (data) => {
    this.toKitchenIdComponent.value=data.value
        this.setState({
            toKitchenId :data.value,
            toKitchenIdErrorText: false,
            toKitchenIdErrorData: ''
        })
        this.toKitchenIdSection.className= this.toKitchenIdSection.className.replace(" has-error", "")
    }



 employeeChange = (data) => {
    this.approverIdComponent.value=data.value
        this.setState({
            approverId :data.value,
            approverIdErrorText: false,
            approverIdErrorData: ''
        })
        this.approverIdSection.className= this.approverIdSection.className.replace(" has-error", "")
    }

 reasonChange = (data) => {
    this.reasonIdComponent.value=data.value
        this.setState({
            reasonId :data.value,
            reasonIdErrorText: false,
            reasonIdErrorData: ''
        })
        this.reasonIdSection.className= this.reasonIdSection.className.replace(" has-error", "")
    }

    






    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>{this.state.subTitle}</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                        

                                         <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Id : </label>
                                                        <div className="col-sm-9">
                                                        {(()=>{
                                                            if(this.state.selectedKitchen && this.state.selectedKitchen.code && this.state.selectedKitchen.code!=="" && this.state.selectedKitchen.code!==undefined){
                                                                return(
                                                                        <p>{this.state.selectedKitchen.code}</p>
                                                                    )
                                                            }else{
                                                                return(
                                                                        <p>NA</p> 
                                                                    )
                                                                }

                                                            })()}
                                                         </div>
                                                    </div>
                                                </div>
                                            </div>

                                         <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-6 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Staff Name : </label>
                                                        <div className="col-sm-9">
                                                        {(()=>{
                                                            if(this.state.selectedKitchen && this.state.selectedKitchen.name && this.state.selectedKitchen.name!=="" && this.state.selectedKitchen.name!==undefined){
                                                                return(
                                                                        <p>{this.state.selectedKitchen.name}</p>
                                                                    )
                                                            }else{
                                                                return(
                                                                        <p>NA</p> 
                                                                    )
                                                                }

                                                            })()}
                                                         </div>
                                                    </div>
                                                </div>
                                            </div>  


                                         <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-6 col-sm-12 col-xs-12" >
                                                    <div className="form-group">
                                                        <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>From Kitchen : </label>
                                                        <div className="col-sm-9">
                                                        {(()=>{
                                                            if(this.state.selectedKitchen && this.state.selectedKitchen.kitchen_name && this.state.selectedKitchen.kitchen_name!=="" && this.state.selectedKitchen.kitchen_name!==undefined){
                                                                return(
                                                                        <p>{this.state.selectedKitchen.kitchen_name}</p>
                                                                    )
                                                            }else{
                                                                return(
                                                                        <p>NA</p> 
                                                                    )
                                                                }

                                                            })()}
                                                         </div>
                                                    </div>
                                                </div>
                                            </div>  

                                       

                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12" style={{zIndex:"2"}}>
                                            <div className="form-group" ref={el => this.toKitchenIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>To Kitchen *</label>
                                                    <div className="col-sm-9" ref={el => this.toKitchenIdComponent = el}>
                                                        
                                                         <Kitchens kitchenChange={this.kitchenChange} selectedValue={this.state.toKitchenId} />

                                                        <span className="help-block"style={{display: this.state.toKitchenIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.toKitchenIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                          <div className="col-md-12 col-sm-12 col-xs-12">

                                            <div className="col-md-6 col-sm-12 col-xs-12" style={{zIndex:"1"}}>
                                                  <div className="form-group">
                                                     <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Moved On *</label>
                                                     <div className="col-sm-9">
                                                        <DateTimeField mode="date" inputFormat="DD-MM-YYYY" dateTime={new Date(this.state.movedOn)} onChange={this.movedOnChange}/>
                                                     </div>
                                                  </div>
                                               </div>

                                            </div>


                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.approverIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Approved By *</label>
                                                    <div className="col-sm-9" ref={el => this.approverIdComponent = el}>
                                                        
                                                         <Employees type="myrm_list" employeeChange={this.employeeChange} selectedValue={this.state.approverId} />

                                                        <span className="help-block"style={{display: this.state.approverIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.approverIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.reasonIdSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reason *</label>
                                                    <div className="col-sm-9" ref={el => this.reasonIdComponent = el}>
                                                        
                                                         <Reasons type="EMPLOYEE_MOVEMENT" reasonChange={this.reasonChange} selectedValue={this.state.reasonId} />

                                                        <span className="help-block"style={{display: this.state.reasonIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.reasonIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.remarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks *</label>
                                                    <div className="col-sm-9">
                                                        <textarea className="form-control" placeholder="Enter Remarks" type="text" ref={el => this.remarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("remarks")}} />
                                                        <span className="help-block"style={{display: this.state.remarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.remarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                        
                                            
                                                </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                            </div>
                                        </div>

                                    </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Move Employee
                                        </button>
                                    </div>
                                </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        employeesmovement: state.employeesmovement,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEmployeeMovement))


// WEBPACK FOOTER //
// ./src/modules/Employees Movement/Components/AddEmployeeMovement.js